/**
 * The deploy SHA, used to tie RUM events to the exact build that produced them.
 * (Not the same as the release version on github.)
 */
export const version = process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA || 'local';

export const service = process.env.NEXT_PUBLIC_DATADOG_SERVICE;
export const env = process.env.NEXT_PUBLIC_DATADOG_ENV;

/**
 * Datadog is off outside of vercel deploys by default.
 * The signal is if the commit SHA from vercel is present (see version above).
 *
 * To turn it on for local work, set this in your local env file:
 *   NEXT_PUBLIC_DATADOG_ENABLE_LOCAL="true"
 * and restart the server
 */
export const isDatadogEnabled =
  version !== 'local' ||
  process.env.NEXT_PUBLIC_DATADOG_ENABLE_LOCAL === 'true';
